<template>
    <v-card max-width="800">
        <v-card-text fluid>
            <v-data-table :headers="dTable.headers" :items="dPriAlumnosInstitutos" :loading="dTable.loading" class="elevation-1" hide-default-footer>
                <template v-slot:no-data>
                    <v-alert :value="true" type="warning" text border="top">
                        <strong>No hay registros para mostrar.</strong>
                    </v-alert>
                </template>
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>OTRO INSTITUTO</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical ></v-divider>
                        <v-btn v-if="dPriAlumnosInstitutos.length==0" color="primary" @click="fuModal()"><v-icon>add</v-icon> Agregar</v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon @click="fuModal(item)" title="Editar">edit</v-icon>
                    <v-icon @click="fuModalDelete()" title="Eliminar">delete</v-icon>
                </template>
            </v-data-table>
        </v-card-text>
        <v-navigation-drawer
            v-model="dModal.dialog"
            right
            temporary
            fixed
            width="400"
        >
            <v-list-item class="text-h5 blue-grey" dark>
                <v-list-item-content>
                    <v-list-item-title class="text-h6">Otro Instituto</v-list-item-title>
                </v-list-item-content>                
                <v-btn icon @click="dModal.dialog = false"><v-icon>close</v-icon></v-btn>
            </v-list-item>
            <v-divider></v-divider>
            <div class="pa-2">
                <v-form ref="refModal" v-if="dPriAlumnosInstituto">
                    <v-row dense>
                        <v-col cols="12">
                            <v-autocomplete v-model="dPriAlumnosInstituto.IdInstituto" label="* Instituto" filled
                                :items="dPriInstitutos"
                                item-value="IdInstituto" item-text="Nombre"
                                :rules="[v => !!v || 'El campo es requerido']">
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="dPriAlumnosInstituto.Comentario"
                                prepend-inner-icon="message"
                                label="Comentario"
                                filled
                                rows="2"
                                row-height="15" :rules="[v => !!v || 'El campo es requerido']">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-btn @click="fuModalSave" color="primary" block><v-icon>save</v-icon> Guardar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
                    <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
                </v-snackbar>
            </div>
        </v-navigation-drawer>
    </v-card>
</template>
<script>
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
    name: 'PriAlumnosInstitutos',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        }
    },
    mounted(){
        if (this.pIdAlumno)
            this.fuLoad();
    },
    data: () => ({
        dModal: {
            dialog: false,
            loading: false,
        },
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'priinstituto.Nombre', text: 'Instituto'},
                {value: 'Comentario', text: 'Comentario'},
            ],
            loading: false,
        },
        dPriAlumnosInstitutos: [],
        dPriAlumnosInstituto: null,
        dPriInstitutos: [],
        dSnackbar: false,
        dIsNew: true,
    }),
    methods: {
        async fuLoad() {
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnosinstitutoByIdAlumno($IdAlumno: Int!){
                        prialumnosinstitutoByIdAlumno(IdAlumno:$IdAlumno){
                            IdAlumno
                            IdInstituto
                            Comentario
                            priinstituto{
                                Nombre
                            }
                        }
                        priinstitutos{
                            IdInstituto
                            Nombre
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: this.pIdAlumno,
                    }
                })
                this.dPriAlumnosInstitutos = response.data.prialumnosinstitutoByIdAlumno;
                this.dPriInstitutos = response.data.priinstitutos;
            } catch (error) {
                console.log(error);
            } finally {
                this.dTable.loading = false;
            }
        },
        fuModal(p_Item){            
            this.dModal.dialog = true;
            this.dPriAlumnosInstituto = {
                IdAlumno: this.pIdAlumno,
                IdInstituto: null,
                Comentario: '',
            };
            if (p_Item){
                // this.dPriAlumnosInstituto = { priinstituto, ...p_Item };
                const { __typename, priinstituto, ...vItem } = p_Item;
                this.dPriAlumnosInstituto = vItem;
                this.dIsNew=false;
            }
        },
        fuModalSave(){            
            if(!this.$refs.refModal.validate()){
                this.dSnackbar = true;
            } else {
                if(this.dIsNew)
                    this.fuCreate();
                else
                    this.fuUpdate();
            }
        },
        async fuCreate () {
            try {
                this.dModal.loading = true;
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnosinstitutoCreate($input: prialumnosinstitutoCreateInput!){
                        prialumnosinstitutoCreate(input: $input){
                            IdInstituto
                        }
                    }`,
                    variables: {
                        input: this.dPriAlumnosInstituto
                    }
                });
                if(response.data){
                    this.fuLoad();
                    this.dModal.dialog = false;
                    Swal.fire('Correcto', 'Registro correcto.', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error')
            } finally {
                this.dModal.loading = false;
            }
        },
        async fuUpdate () {
            try {
                this.dModal.loading = true;
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnosinstitutoUpdate($input: prialumnosinstitutoUpdateInput!){
                        prialumnosinstitutoUpdate(input: $input){
                            IdInstituto
                        }
                    }`,
                    variables: {
                        input: this.dPriAlumnosInstituto
                    }
                });
                if(response.data){
                    this.fuLoad();
                    this.dModal.dialog = false;
                    Swal.fire('Correcto', 'Registro correcto.', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error')
            } finally {
                this.dModal.loading = false;
            }
        },
        fuModalDelete(){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                html: '<h3>Se va eliminar el registro.</h3>',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    this.fuDelete();
                },
            }).then(() => {
            })
        },
        async fuDelete() {
            try {
                this.dTable.loading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnosinstitutoDelete($IdAlumno: Int!){
                        prialumnosinstitutoDelete(IdAlumno: $IdAlumno){
                            IdAlumno
                        }
                    }`,
                    variables: {
                        IdAlumno: this.pIdAlumno
                    }
                });
                if(response.data){
                    this.fuLoad();
                    Swal.fire('Correcto', 'Registro eliminado.', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro no eliminado.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro no eliminado.', 'error')
            } finally {
                this.dTable.loading = false;
            }
        },
    }
}
</script>
